import { Box } from "@mui/material";
import { ReactNode } from "react";
import StatisticsBarItem from "./UXStatisticsBarItem";

type Props = {
    children: ReactNode[]
}

const UXStatisticsBar = ({ children }: Props) => {
    return (
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 2 }}>
            {children}
        </Box>
    )
}

export default UXStatisticsBar;